// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__xd-wI","label":"LoginForm_label__HRbQ4","input":"LoginForm_input__b9s1W","button":"LoginForm_button__zLSeM"};